import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B4E2287E-8872-48AD-B765-83D82AF66CA3
 * name home-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-outline.svg
 * tags
 * - Home Automation 
 * - Places 
 */
export const HomeOutlineIcon = createSvgIcon(<><path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22" /></>, 'HomeOutlineIcon');
export default HomeOutlineIcon